<div class="container-fluid">
    <div class="master-form">
        <div class="title-tab-step text-center">
        </div>
        <form novalidate [formGroup]="SecLoginsForm">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-3">
                        <div class="form-group">
                            <!-- <sanabel-selectize appcode="1041" formControlName="groupId"></sanabel-selectize> -->
                            <sanabel-selectize appcode="1072" formControlName="userId"></sanabel-selectize>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-3">
                        <div class="form-group">
                            <sanabel-selectize appcode="1065" formControlName="branchId"></sanabel-selectize>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col">
                            <btns-ctrl [appCodes]="[1]" [disabled]="SecLoginsForm.invalid"
                                (clicked)="onClicked($event)"></btns-ctrl>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>